module.exports = __webpack_public_path__ + "media/images/project/down-arrow-white-88d088d6e0e1c7f020f487741a2c5a78.svg";